import React, { useEffect, useState } from 'react';

function ThankYou() {
  const [response, setResponse] = useState(null);

  useEffect(() => {
    // Clean up any service workers that might be causing issues
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for(let i = 0; i < registrations.length; i++) {
          registrations[i].unregister().catch(() => {
            // Ignore errors
          });
        }
      }).catch(() => {
        // Ignore errors
      });
    }

    // Try to get the response from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const responseParam = urlParams.get('response');
    if (responseParam) {
      setResponse(responseParam);
    }
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0a0e27 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        background: 'rgba(26, 31, 58, 0.9)',
        borderRadius: '24px',
        padding: '60px 40px',
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center',
        border: '1px solid rgba(59, 130, 246, 0.3)',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
      }}>
        {/* Logo */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '30px'
        }}>
          <img 
            src="/darklogo.jpeg" 
            alt="ConvrsAI by Market Wavegen" 
            style={{
              height: '48px',
              width: 'auto'
            }}
          />
        </div>

        {/* Success Icon */}
        <div style={{
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px',
          boxShadow: '0 10px 40px rgba(16, 185, 129, 0.4)'
        }}>
          <span style={{ fontSize: '48px', color: 'white' }}>✓</span>
        </div>

        {/* Main Message */}
        <h2 style={{
          fontSize: '28px',
          fontWeight: '600',
          color: '#ffffff',
          marginBottom: '16px'
        }}>
          Thank You!
        </h2>

        <p style={{
          fontSize: '18px',
          color: '#94a3b8',
          lineHeight: '1.6',
          marginBottom: '30px'
        }}>
          {response === 'yes' 
            ? "We're thrilled to hear from you! Your positive response has been recorded. Our team will be in touch soon."
            : response === 'no'
            ? "Thank you for your feedback. Your response has been recorded. We appreciate you taking the time to respond."
            : "Your response has been recorded successfully. We appreciate your engagement with ConvrsAI by Market Wavegen."}
        </p>

        {/* Response Badge */}
        {response && (
          <div style={{
            display: 'inline-block',
            padding: '12px 24px',
            borderRadius: '50px',
            background: response === 'yes' 
              ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' 
              : 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
            color: 'white',
            fontWeight: '600',
            fontSize: '16px',
            marginBottom: '30px',
            boxShadow: response === 'yes'
              ? '0 4px 20px rgba(16, 185, 129, 0.3)'
              : '0 4px 20px rgba(239, 68, 68, 0.3)'
          }}>
            Your Response: {response.toUpperCase()}
          </div>
        )}

        {/* Divider */}
        <div style={{
          width: '100%',
          height: '1px',
          background: 'rgba(148, 163, 184, 0.2)',
          margin: '30px 0'
        }}></div>

        {/* Features Section */}
        <h3 style={{
          fontSize: '20px',
          fontWeight: '600',
          color: '#e2e8f0',
          marginBottom: '20px'
        }}>
          What We Offer
        </h3>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '16px',
          marginBottom: '30px'
        }}>
          {[
            { icon: '', title: 'Email Campaigns', desc: 'Intelligent email marketing' },
            { icon: '', title: 'AI Calling', desc: 'Automated voice calls' },
            { icon: '', title: 'Data Intelligence', desc: 'Advanced analytics' },
            { icon: '', title: 'Automation', desc: 'Smart workflows' }
          ].map((feature, index) => (
            <div key={index} style={{
              background: 'rgba(59, 130, 246, 0.1)',
              border: '1px solid rgba(59, 130, 246, 0.2)',
              borderRadius: '12px',
              padding: '16px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '28px', marginBottom: '8px' }}>{feature.icon}</div>
              <div style={{ color: '#e2e8f0', fontWeight: '600', fontSize: '14px' }}>{feature.title}</div>
              <div style={{ color: '#94a3b8', fontSize: '12px', marginTop: '4px' }}>{feature.desc}</div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <p style={{
          color: '#64748b',
          fontSize: '14px'
        }}>
          Want to learn more? Visit our website or contact our team.
        </p>

        {/* Footer */}
        <footer style={{
          marginTop: '30px',
          paddingTop: '20px',
          borderTop: '1px solid rgba(148, 163, 184, 0.1)'
        }}>
          <p style={{
            color: '#64748b',
            fontSize: '12px'
          }}>
            © 2026 convrsai. All rights reserved.
          </p>
        </footer>
      </div>
    </div>
  );
}

export default ThankYou;
